import { resetLessonEntry } from 'ducks/workItem';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { Divider, Fixed, Flex, Heading, Message, Text } from 'rebass';
import { bindActionCreators } from 'redux';
import { Overflow, BoldLabel, PvBox, PvButton, PvButtonOutline } from 'styles/CustomComponents';
import ConfirmButton from '../ConfirmButton';
import { PvDatePicker } from 'components/form/PvDatePicker';
import { PvSelect } from 'components/form/PvSelect';
import { LessonTypeIcon } from '../../util/IconUtil';
import { PvCourseBadge } from '../PvBadge';
import { isDayBlockedLessonEdit } from '../../containers/search/isDayBlocked';
import { formatLoggedUserFullName } from '../../util/FormatUtil';

class EditTheoryLessonEntryModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datePickerOpen: false,
      entryEdit: {},
    };

    const removeClick = () => {
      this.props.removeFn(this.props.applicantId, this.props.lessonEntry.entityId);
    };

    const saveClick = () => {
      const requestObject = {
        lessonEntryEntityId: this.props.lessonEntry.entityId,
        newDate: this.state.entryEdit.lessonEndTime,
        newLesson: this.state.entryEdit.lesson,
        lessonStatus: this.state.entryEdit.lessonStatus,
      };
      this.props.saveFn(requestObject);
    };

    const updateEntryEdit = (entryEdit) => {
      this.setState(
        {entryEdit: Object.assign(this.state.entryEdit, entryEdit)}
      );
    };

    this.removeClick = removeClick.bind(this);
    this.saveClick = saveClick.bind(this);
    this.updateEntryEdit = updateEntryEdit.bind(this);
  }

  componentWillMount() {
    this.setState({
      entryEdit: {
        lessonEndTime: this.props.editMode ? moment.unix(this.props.lessonEntry.lessonEndTime / 1000) : moment(),
        examClass: this.props.lessonEntry.course.examClasses.map(item => item.name).join(", "),
        lesson: this.props.lessonEntry.lesson,
        lessonStatus: this.props.lessonEntry.lessonStatus
      },
    });
  }

  componentWillUnmount() {
    this.props.resetLessonEntry();
  }

  render() {
    const {
      applicantNameAndTrafiId,
      error,
      hideModal,
      lessonStatuses,
      lessonEntry,
      loggedUser,
      editMode,
    } = this.props;

    const { datePickerOpen, entryEdit } = this.state;

    return (
      <React.Fragment>
        <Fixed
          onClick={() => hideModal()}
          top={0}
          right={0}
          bottom={0}
          left={0}
        />
        <Overflow overflow={['auto', 'visible', 'visible']} p={3} width={['90%', '80%', '70%']}>
          <Heading mb={3} fontSize='19px'>
            <LessonTypeIcon type={lessonEntry.lesson.lessonType} style={{ verticalAlign: "text-bottom", marginRight: "5px" }}/>
            {editMode && 
              <Translate value={lessonEntry.lesson.lessonType === 'TRAINING' ? 'app.edit_traininglesson_entry' : 'app.edit_theorylesson_entry'} />
            }
            {!editMode &&
              <Translate value={lessonEntry.lesson.lessonType === 'TRAINING' ? 'app.complete_undone_traininglesson' : 'app.complete_undone_theorylesson'} />
            }
          </Heading>
          
          <Flex flexWrap='wrap'>
            <PvBox w={1 / 2} mb={3}>
              <BoldLabel fontWeight='bold' mb={2}><Translate value='app.name' /></BoldLabel>
              <Text>{applicantNameAndTrafiId}</Text><PvCourseBadge course={lessonEntry.course}/>
            </PvBox>
            <PvBox pl={2} w={1 / 2} mb={3}>
              <BoldLabel mb={2}><Translate value='app.supervisor' /></BoldLabel>
              <Text>{[formatLoggedUserFullName(loggedUser), `(${lessonEntry.supervisor})`].join(" ")}</Text>
            </PvBox>
            <PvBox mb={3} w={[1, 1, 1 / 2]}>
              <BoldLabel mb={2}><Translate value='app.lesson_completed' /></BoldLabel>
              <PvDatePicker
                date={entryEdit.lessonEndTime}
                onDateChangeFn={(date) => this.updateEntryEdit({lessonEndTime: date})}
                focused={datePickerOpen}
                onFocusChangeFn={({ focused }) => this.setState({ datePickerOpen: focused })}
                isDayBlocked={isDayBlockedLessonEdit}
              />
            </PvBox>
            {editMode &&
            <PvBox mb={3} w={[1, 1, 1 / 2]} pl={[0, 0, 2]}>
              <BoldLabel mb={2}><Translate value='app.lesson_status' /></BoldLabel>
              <PvSelect
                placeholder=''
                options={lessonStatuses.map(ls => {
                  return {value: ls, label: <Translate value={`app.${ls.toLowerCase()}`} />};
                })}
                value={{
                  value: entryEdit.lessonStatus,
                  label: <Translate value={`app.${entryEdit.lessonStatus.toLowerCase()}`} />
                }}
                onChange={(option) => {
                  this.updateEntryEdit({lessonStatus: option.value});
                }}
              />
            </PvBox>
            }
          </Flex>
          <Flex flexWrap='wrap'>
            <PvBox pr={[0, 0, 2]} mb={3} w={[1, 1, 1 / 2]}>
              <BoldLabel mb={2}><Translate value='search.exam_class' /></BoldLabel>
              <Text>{entryEdit.examClass}</Text>
            </PvBox>
            <PvBox pl={[0, 0, 2]} mb={3} w={[1, 1, 1 / 2]}>
              <BoldLabel mb={2}><Translate value='datatable.topic' /></BoldLabel>
              <Text>{lessonEntry.lesson.description}</Text>
            </PvBox>
          </Flex>
          {error && <Message mt={3} bg='red'><Translate value={error} /></Message>}
          <Divider
            my={2}
            w={1}
            borderBottom={2}
            borderColor='grays.1'
          />
          <Text py={2} textAlign='center'>
            <PvButtonOutline
              width='12em'
              my={1}
              ml={2}
              onClick={() => hideModal()}>
              <Translate value='app.cancel' />
            </PvButtonOutline>
            {editMode &&
            <ConfirmButton
              width='12em'
              my={1}
              ml={2}
              onClick={this.removeClick}>
              <Translate value='app.remove_lesson_entry' />
            </ConfirmButton>
            }
            <PvButton
              width='12em'
              my={1}
              ml={2}
              disabled={!entryEdit.lessonEndTime || !entryEdit.examClass || !entryEdit.lesson}
              onClick={this.saveClick}>
              <Translate value='app.save' />
            </PvButton>
          </Text>
        </Overflow>
      </React.Fragment>
    );
  }
};

EditTheoryLessonEntryModal.propTypes = {
  applicantNameAndTrafiId: PropTypes.string,
  applicantId: PropTypes.number,
  error: PropTypes.string,
  examClasses: PropTypes.array,
  lessonStatuses: PropTypes.array,
  hideModal: PropTypes.func,
  modalType: PropTypes.string,
  lessonEntry: PropTypes.object,
  removeFn: PropTypes.func,
  saveFn: PropTypes.func,
  supervisor: PropTypes.string,
  resetLessonEntry: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {
  return {
    lessonStatuses: state.general.lessonStatuses,
    loggedUser: state.userState.user,
    editMode: ownProps.modalType !== 'COMPLETE_UNDONE_ENTRY'
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  resetLessonEntry: () => resetLessonEntry(),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditTheoryLessonEntryModal);


// WEBPACK FOOTER //
// ./src/components/modal/EditTheoryLessonEntryModal.jsx